<script>
    export let text;
</script>

<!-- Prevents html to be rendered using the @html tag-->
{text}